import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Tooltip,
  Legend,
  Cell,
} from "recharts";
import type { ChartDataPoint } from "../../types/reports.types";

interface PieChartCardProps {
  data?: ChartDataPoint[];
  colors?: string[];
  loading?: boolean;
}

export default function PieChartCard({
  data = [],
  colors = [],
  loading = false,
}: PieChartCardProps) {
  if (loading) {
    return <div className="chartState">Loading chart...</div>;
  }

  if (!data.length) {
    return <div className="chartState empty">No distribution data available</div>;
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <PieChart>
        <Pie
          data={data}
          dataKey="value"
          nameKey="name"
          cx="50%"
          cy="50%"
          outerRadius={100}
          label={{ fontSize: 10 }}
          isAnimationActive
        >
          {data.map((entry, index) => (
            <Cell
              key={`${entry["name"]}-${index}`}
              fill={colors[index % colors.length]}
            />
          ))}
        </Pie>
        <Tooltip />
        <Legend wrapperStyle={{ fontSize: 10 }} />
      </PieChart>
    </ResponsiveContainer>
  );
}
